import { Controller } from "@hotwired/stimulus"
import { useDebounce } from "stimulus-use"

// Connects to data-controller="analytics"
export default class extends Controller {
  static targets = ["scroll"]
  static debounces = ["onScroll"]
  static values = {
    debug: { type: Boolean, default: true },
    trackOutbound: Object,
  }

  initialize() {
    useDebounce(this)

    this.boundOnScroll = this.onScroll.bind(this)

    if (this.enableOutboundTracking()) {
      this.trackLinks()
    }
  }

  scrollTargetConnected(element) {
    element.addEventListener("scroll", this.boundOnScroll)
  }

  scrollTargetDisconnected(element) {
    element.removeEventListener("scroll", this.boundOnScroll)
  }

  onScroll(event) {
    this.dispatch("scroll-start")

    if (
      event.target &&
      event.target.scrollHeight - Math.ceil(event.target.scrollTop) ===
        event.target.clientHeight
    ) {
      this.dispatch("scroll-end")
    }
  }

  track(event) {
    const type = event.type
    const { name, category, action, label } =
      event?.params?.track?.[type] || event?.params?.track || {}

    if (this.debugValue) {
      console.log("analytics#track", { name, category, action, label })
    }

    if (typeof gtag === "function" && !!(name || category || action || label)) {
      gtag("event", name, {
        'category': category,
        'action': action,
        'label': label
      })
    }
  }

  enableOutboundTracking() {
    return (
      typeof this.trackOutboundValue === "object" &&
      (this.trackOutboundValue.category ||
        this.trackOutboundValue.action ||
        this.trackOutboundValue.label)
    )
  }

  trackOutbound({ target: { href } }) {
    this.track({
      params: {
        track: JSON.parse(
          JSON.stringify(this.trackOutboundValue).replace("[href]", href)
        ),
      },
    })
  }

  trackLinks() {
    if (!this.outboundLinks) {
      return
    }

    this.outboundLinks.forEach(link => {
      link.addEventListener("click", event => this.trackOutbound(event))
    })
  }

  get outboundLinks() {
    return this.element.querySelectorAll('a[href^="http"]')
  }
}
